import React from 'react';
import ChanceFailListContainer from '../../containers/chance-fail/ChanceFailListContainer';

const ChanceFailListPage = () => {
  return <ChanceFailListContainer />;
};

export default ChanceFailListPage;
